import { styled } from "@mui/material";

export const Styled = {
    List: styled("ul")`
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 10px;
    `,
};
